var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _rect4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 144,
    viewBox: "0 0 148 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 144,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 831,
    transform: "translate(-646 -293)",
    fill: "#FBF8F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -346,
    y: -156,
    width: 840,
    height: 636,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.0674 104.259C95.7771 104.685 97.3668 106.558 98.0481 110.646",
    stroke: "#8AAAF5",
    strokeWidth: 1.81513
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.928 98.4756C102.637 98.9014 103.158 107.241 102.59 110.505",
    stroke: "#8AAAF5",
    strokeWidth: 1.81513
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.396 103.835C109.687 104.261 107.567 107.704 107.567 111.805",
    stroke: "#8AAAF5",
    strokeWidth: 1.81513
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.726 50.321C117.21 59.4051 111.201 77.2896 109.261 85.0963C104.719 101.987 105.855 105.82 108.552 107.239C111.816 108.958 117.273 101.176 124.449 92.903C136.514 78.9932 141.907 71.4704 146.733 60.683C151.559 49.8955 136.372 38.9658 125.726 50.321Z",
    fill: "#8AAAF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3336 139.306L89.9541 110.13H117.835C116.756 119.191 114.512 137.968 114.174 140.587C113.836 143.206 111.405 143.671 110.231 143.576H96.9948C94.0659 143.576 93.3336 140.729 93.3336 139.306Z",
    fill: "#4F3FEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7646,
    y: 78.8828,
    width: 10.4938,
    height: 3.31385,
    transform: "rotate(8.82743 24.7646 78.8828)",
    fill: "#3A5CA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7682 142.599L14.1413 135.568C8.24625 134.796 4.01606 129.875 4.69304 124.578L19.3897 9.5925C20.0667 4.29576 25.3939 0.628175 31.2889 1.40103L84.9158 8.43162C90.8109 9.20448 95.0411 14.1255 94.3641 19.4222L79.6674 134.408C78.9904 139.704 73.6633 143.372 67.7682 142.599Z",
    fill: "#003C82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2487 10.4111L50.2374 8.31123C49.959 8.27478 49.703 8.47549 49.6673 8.75589C49.6313 9.03746 49.8298 9.29648 50.107 9.33278L66.1184 11.4326C66.3968 11.4691 66.6528 11.2684 66.6885 10.988C66.7245 10.7064 66.526 10.4474 66.2487 10.4111Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4189 9.86914L89.9558 18.3096C89.9558 18.3096 81.0716 96.8524 81.0497 97.1731C81.0278 97.4938 77.5494 124.61 77.5494 124.61L9.29551 116.162L22.4189 9.86914Z",
    fill: "#FCEEEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4288 97.8728C76.7292 90.719 67.5788 87.7004 63.8411 87.0853C55.4666 84.9562 47.6964 84.594 50.0729 75.5882C52.7697 65.3684 73.0672 67.2137 83.4288 76.5818C93.074 85.3021 99.468 101.989 96.6292 105.112C93.7904 108.234 91.8032 106.815 83.4288 97.8728Z",
    fill: "#8AAAF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2089 45.1078C36.7431 47.2384 35.6652 50.1847 35.385 52.9777C35.27 54.1236 35.2892 55.2436 35.471 56.271",
    stroke: "#FB6F55",
    strokeWidth: 1.21008
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7001 42.599C34.0103 42.0751 34.4656 38.8383 34.4398 37.8359C36.1126 41.0909 41.7124 42.5967 44.2963 42.9073C44.4564 45.3827 45.2518 47.1158 45.7241 45.8277C46.1964 44.5396 46.71 42.9857 48.8371 43.316C50.1665 43.5224 52.4706 44.6868 51.8987 48.1481C51.4567 50.8236 48.8702 52.347 47.8265 52.6387C47.4261 58.0224 49.1784 61.5993 52.0618 62.3194L52.0311 67.2097C41.7761 70.79 34.1591 67.2097 32.8825 64.6565L33.5208 60.1885C37.0744 60.1885 37.7508 56.8426 37.8152 54.6743C31.8833 54.2977 33.1996 49.3285 33.4473 47.7333C33.6822 46.2211 31.2678 45.0377 31.4443 44.2342C31.6208 43.4308 32.9619 43.8458 33.7001 42.599Z",
    fill: "#F4B7A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1789 30.649C38.947 29.5259 35.0017 34.3823 34.4649 37.8387C36.0552 41.6255 42.2196 43.2856 44.2382 43.1453C44.2382 43.1453 43.4666 46.361 45.0309 46.8082C46.5952 47.2554 45.8418 43.3399 48.0018 43.4575C50.7019 43.6045 52.3566 45.223 51.5127 48.904C50.8375 51.8488 48.2285 51.9337 47.2123 52.0482C47.2717 53.4189 47.2226 57.479 49.0377 59.8991L56.9572 61.1857C57.1868 57.9539 57.6764 50.2424 57.7981 45.2511C57.9501 39.012 55.2188 32.0529 46.1789 30.649Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5723 44.3848C36.049 45.8751 38.7074 46.996 40.4125 45.1364",
    stroke: "black",
    strokeWidth: 0.582659,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9077 118.335L33.5208 60.1879L18.9636 76.5646L14.3521 116.769L26.9077 118.335Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1165 62.7416C25.2668 60.1733 30.2812 59.8733 33.5205 60.1885L18.7842 82.8906L14.8091 116.773L9.36373 116.168L12.5407 89.98C12.5407 89.98 10.8173 75.8566 12.1627 73.3449C14.6217 68.7546 17.4088 64.0918 20.1165 62.7416Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9361 69.5798C37.7158 68.829 31.4907 66.5545 31.4907 68.3697L32.0955 68.9747C33.3587 69.6367 36.1565 70.3305 36.9361 69.5798Z",
    fill: "#F4B7A8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3571 60.5049C39.3571 67.6422 33.8221 81.1631 12.1641 80.633",
    stroke: "#FB6F55",
    strokeWidth: 1.21008
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.53343,
    cy: 1.56998,
    rx: 1.53343,
    ry: 1.56998,
    transform: "matrix(-0.984423 0.175814 0.175814 0.984423 49.6357 47.1934)",
    fill: "#FB6F55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6536 120.225L52.0632 62.3184L61.6069 79.9743L53.107 121.585L41.6536 120.225Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3443 62.3624C56.1338 63.0245 62.0378 67.6226 65.3733 71.9995C68.7928 76.4866 77.9134 99.781 77.4742 113.142C77.0349 126.504 66.7522 126.598 62.3481 125.243C54.4826 122.823 42.3819 103.462 36.9365 91.3608L47.2223 82.2852L65.3733 111.932L59.9279 89.5457L55.0876 72.6045L52.6677 64.1336L52.0626 62.3188L52.3443 62.3624Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7244 54.4385C75.6924 41.0037 78.1759 35.9061 81.0147 34.567C88.5376 31.0184 105.854 41.0962 106.564 68.4907C107.274 95.8851 105.286 102.698 102.164 102.272C99.0411 101.847 98.4734 98.582 94.0732 84.1041C90.7515 73.1745 87.9698 68.3484 81.7244 54.4385Z",
    fill: "#8AAAF5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4596 49.0599C46.7505 56.1748 45.4077 61.7651 40.4091 61.2026C37.4239 60.8667 35.9294 58.8637 35.4705 56.27",
    stroke: "#FB6F55",
    strokeWidth: 1.21008
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2379 84.1003C45.2379 84.1003 44.2234 82.0087 43.5926 78.6717C42.9618 75.3347 38.1504 70.1808 37.5419 69.5792C37.4567 69.4949 36.5183 71.1352 36.4096 71.3259C35.9924 70.9275 35.6317 70.5795 35.3998 70.3487C33.7254 68.6816 32.9616 68.101 32.9616 68.101C32.0957 67.1591 31.0381 68.0433 31.4911 68.9742C31.9441 69.9051 32.1485 69.7467 33.7732 72.2349L31.2243 70.3487C30.7516 69.8605 29.8416 69.3108 29.4092 69.7437C28.9538 70.1995 28.9933 70.4471 29.4092 70.9538L31.6114 73.7067L28.9452 71.9981C28.3189 71.5354 27.9714 71.1338 27.4148 71.691C26.8582 72.2481 27.3527 72.9 27.9199 73.4858L29.7534 75.9358L27.4148 74.5231C26.3241 73.9782 25.9768 73.9933 25.5997 74.5156C25.114 75.1883 26.753 76.505 27.4148 77.1885L39.7924 88.9406L45.2379 84.1003Z",
    fill: "#F4B7A8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4072 99.0539L17.0783 53.6855L13.6756 55.954L8.76074 93.7609L11.4072 99.0539Z",
    fill: "#003C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.8a7102f5fa7ed937fcb6503ac6b06682.svg";
export { ForwardRef as ReactComponent };